export const visibleDocumentDrawerSelector = (state) =>
  state.newDocumentStore.visibleDocumentDrawer;
export const documentDrawerSelector = (state) =>
  state.newDocumentStore.documentDrawer;
export const chosenFilterIdSelector = (state) =>
  state.newDocumentStore.chosenFilterId;
export const chosenFilterNameSelector = (state) =>
  state.newDocumentStore.chosenFilterName;
